import Markdown from "markdown-to-jsx";
import React from "react";
import { twMerge } from "tailwind-merge";
import { ContentBlockFeatureSectionWithRoundedIconsType } from "../../../types/blocks";
import CTAs from "../../molecules/ctas";

const BlockFeatureSectionWithRoundedIcons = ({
  headline,
  copytext,
  features,
  ctas,
  block_settings: { background_color, html_id } = {
    background_color: "bg-white dark:bg-secondary-900",
  },
}: Omit<ContentBlockFeatureSectionWithRoundedIconsType, "type">) => {
  return (
    <section
      className={twMerge(background_color, "relative z-10 scroll-mt-20")}
      id={html_id}
    >
      <div className="max-w-screen-xl px-4 py-8 mx-auto space-y-8 lg:px-6 sm:py-16 lg:py-24 lg:space-y-16">
        <div className="max-w-3xl mx-auto space-y-4 text-center">
          <h2 className="text-3xl font-extrabold leading-tight tracking-tight text-secondary-900 sm:text-4xl dark:text-white">
            <Markdown>{headline}</Markdown>
          </h2>
          <p className="text-base font-normal text-secondary-500 md:text-lg dark:text-secondary-400">
            {copytext}
          </p>
        </div>

        <div className="p-4 rounded-lg sm:p-12 bg-secondary-50 dark:bg-secondary-800">
          <div className="grid grid-cols-1 gap-8 sm:gap-12 lg:grid-cols-2">
            {features.map((feature, index) => (
              <div
                className="flex flex-col items-start gap-4 sm:gap-5 sm:flex-row"
                key={index}
              >
                <div className="flex items-center justify-center w-16 h-16 bg-white rounded-full dark:bg-secondary-700 lg:w-24 lg:h-24 shrink-0">
                  <Markdown>{feature.icon}</Markdown>
                </div>
                <div className="space-y-3">
                  <h3 className="text-xl font-bold text-secondary-900 sm:text-2xl dark:text-white">
                    {feature.headline}
                  </h3>
                  <Markdown
                    className="space-y-3 text-base font-normal text-secondary-500 sm:text-lg dark:text-secondary-400"
                    options={{ forceBlock: true }}
                  >
                    {feature.copytext}
                  </Markdown>
                </div>
              </div>
            ))}
          </div>
        </div>

        {ctas.length > 0 && <CTAs ctas={ctas} className="justify-center" />}
      </div>
    </section>
  );
};

export default BlockFeatureSectionWithRoundedIcons;
